import { styled } from '@mui/material/styles';
import Button, { buttonClasses } from '@mui/material/Button';
import { circularProgressClasses } from '@mui/material/CircularProgress';
import { loadingButtonClasses } from './loadingButtonClasses';

export const LoadingButtonRoot = styled(Button, {
  name: 'AFLoadingButton',
  shouldForwardProp: prop => prop !== 'loading'
})(({ theme, loading, variant }) => ({
  pointerEvents: loading ? 'none' : 'initial',
  ...(loading && {
    [`& .${buttonClasses.startIcon}`]: {
      visibility: 'hidden'
    },
    [`& .${loadingButtonClasses.buttonContent}`]: {
      visibility: 'hidden'
    }
  }),
  [`& .${circularProgressClasses.root}`]: {
    position: 'absolute',
    zIndex: 10,
    color:
      variant === 'contained'
        ? theme.palette.primary.contrastText
        : theme.palette.primary.main
  }
}));
